import React from 'react';
import CustomOfferStripeGate from './CustomOfferStripeGate';

// What the freelancer sees instead of the offer form while their Stripe
// account cannot take the customer's card payment yet.
export const Blocked = {
  component: props => (
    <div style={{ maxWidth: 560 }}>
      <CustomOfferStripeGate {...props}>
        <p>Tarjouslomake</p>
      </CustomOfferStripeGate>
    </div>
  ),
  props: { status: 'blocked', onGetStripeConnectAccountLink: () => null },
  group: 'transaction',
};

export const Checking = {
  component: props => (
    <CustomOfferStripeGate {...props}>
      <p>Tarjouslomake</p>
    </CustomOfferStripeGate>
  ),
  props: { status: 'checking', onGetStripeConnectAccountLink: () => null },
  group: 'transaction',
};
